<template>
    <card-renderless v-slot="{
        title,
        subtitle,
        link,
        startDate,
        endDate,
        simpleStartDate,
        simpleEndDate,
        startDay,
        endDay,
        startMonth,
        endMonth,
        startYear,
        endYear,
    }">
        <div
             class="relative flex flex-col w-full h-full bg-white border border-transparent rounded shadow-md select-none t3m-Card t3m-Card--flx t3m-Card--flx-loose t3m-Card--flexColumn t3m-Card--flx-light card">
            <div class="relative flex flex-grow max-h-full p-4 card-body">
                <div class="flex-none t3m-Event-list-item-column-1">
                    <div class="pl-2 text-right t3m-Event-date font-condensed">
                        <div v-if="simpleStartDate !== simpleEndDate"
                             class="inline-block align-top t3m-Event-date-start"
                             itemprop="startDate"
                             :content="startDate">
                            <span class="block text-2xl t3m-Event-date-day ">
                                {{ startDay }}
                            </span>
                            <span v-if="startMonth !== endMonth"
                                  class="block leading-none uppercase t3m-Event-date-month">
                                {{ startMonth }}
                            </span>
                            <span v-if="startYear !== endYear"
                                  class="t3m-Event-date-year">
                                {{ startYear }}
                            </span>
                        </div>
                        <div class="inline-block align-top t3m-Event-date-end"
                             itemprop="endDate"
                             :content="endDate">
                            <span class="block text-2xl t3m-Event-date-day">
                                <span v-if="simpleStartDate !== simpleEndDate"
                                      class="text-2xl px-0.5 t3m-Event-date-dash">–</span>{{
                                              endDay
                                      }}
                            </span>
                            <span class="block leading-none uppercase t3m-Event-date-month">
                                {{ endMonth }}
                            </span>
                            <span class="t3m-Event-date-year">
                                {{ endYear }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="flex-auto pl-6 ml-6 border-l-2 t3m-Event-list-item-column-2 border-t3m-body">
                    <h3 class="mb-2 font-bold t3m-Card-title card-title h4">
                        <span class="t3m-Card-title-inner t3m-u-flx-readability">
                            <a class="text-inherit hover:text-primary"
                               v-if="link.length"
                               v-html="title"
                               :href="link"
                               :aria-label="title"></a>
                            <span v-if="!link.length"
                                  v-html="title"></span>
                        </span>
                    </h3>
                    <div v-if="subtitle"
                         class="t3m-Card-text t3m-u-flx-readability"
                         v-html="subtitle"></div>
                    <a v-if="link.length"
                       class="absolute p-0.5 text-white rounded-full hover:text-white bottom-3 right-3 t3m-Card-btn t3m-btn-primary-icon-plus-xs bg-primary hover:bg-primary-hover"
                       :href="link"
                       aria-label="Event details">
                        <span class="sr-only">
                            Event details
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-3 h-3"
                             viewBox="0 0 448 512"
                             fill="currentColor">
                            <path
                                  d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
    components: {
        CardRenderless,
    },
};
</script>
